import React from 'react'
import { defineMessages, injectIntl } from 'react-intl'
import { Input, TextInput } from '../../Input'
import { required, minLength } from '../../../utils/validations'

const messages = defineMessages({
  label: {
    id: 'FirstNameInput.FirstName',
    defaultMessage: 'First Name',
    description: 'The label for the first name text input.',
  },
})

export const FirstNameInput = injectIntl(({ intl }) => {
  const { formatMessage } = intl
  const validate = (value) => {
    if (!value) return required(value, formatMessage)
    return minLength(value, 2, formatMessage)
  }

  return (
    <Input
      component={TextInput}
      name='firstName'
      label={formatMessage(messages.label)}
      placeholder={formatMessage(messages.label)}
      validate={validate}
      maxLength={56}
      required
    />
  )
})
